import { createContext } from "react"

export interface InstructionInterface {
  _id: any,
  contentFr: string,
  contentAr: string,
}

export const DefaultInstructionInterface: InstructionInterface = {
  _id: "",
  contentFr: "",
  contentAr: "",
}

export interface ShowInstructionInterface {
  showSuccessMsg: boolean,
  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showEditModal: boolean,
  setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean,
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedInstruction: InstructionInterface,
  setSelectedInstruction: (selectedInstruction: InstructionInterface) => void,
}

export const  DefaultShowInstructionInterface: ShowInstructionInterface = {
  showSuccessMsg: false,
  setShowSuccessMsg: () => {},
  showEditModal: false,
  setShowEditModal: () => {},
  showDeleteModal: false,
  setShowDeleteModal: () => {},
  selectedInstruction: DefaultInstructionInterface,
  setSelectedInstruction: () => {},
}

export const ShowInstructionContext = createContext(DefaultShowInstructionInterface)

export interface DataInstructionInterface {
  contentFr: string, setContentFr: (contentFr: string) => void,
  contentAr: string, setContentAr: (contentAr: string) => void,
}

export const DefaultDataInstructionInterface: DataInstructionInterface = {
  contentFr: "", setContentFr: () => {},
  contentAr: "", setContentAr: () => {},
}

export const DataInstructionContext = createContext(DefaultDataInstructionInterface)


